module.exports = __webpack_public_path__ + "2a4964a054cbddc7b7b5b59e59d52acb.pdf";